











































































import Vue from 'vue'
import config from '@/config'
import { PropertyMap } from '@/components/gmap/'
import { getNestedValue } from '@/util/helpers'
import { MapMarker } from '@/interfaces/gmap/Map'
import { ValidatedResponse } from '@/interfaces/app/ValueObjects'

export default Vue.extend({
  components: {
    PropertyMap,
  },
  data(): { showStreetView: boolean } {
    return {
      showStreetView: false,
    }
  },
  computed: {
    unitInfo(): any {
      return getNestedValue(
        this.$store.getters['valuationEdit/data'],
        ['info'],
        {}
      )
    },
    unitMarker(): MapMarker | undefined {
      if (this.unitMarkerPosition.valid) {
        const marker: MapMarker = {
          id: 1,
          position: this.unitMarkerPosition.value!,
          icon: require('@/assets/icons/map/pointer–blue.svg'),
        }

        return marker
      }
    },
    lat(): ValidatedResponse<number> {
      const lat = getNestedValue(this.unitInfo, ['gpsNumeric', 'lat'], false)
      if (!lat) {
        return { valid: false }
      }

      return { valid: true, value: Number(lat) }
    },
    lng(): ValidatedResponse<number> {
      const lng = getNestedValue(this.unitInfo, ['gpsNumeric', 'lng'], false)
      if (!lng) {
        return { valid: false }
      }

      return { valid: true, value: Number(lng) }
    },
    unitMarkerPosition(): ValidatedResponse<MapMarker['position']> {
      if (!this.lat.valid || !this.lng.valid) {
        return { valid: false }
      }

      return {
        valid: true,
        value: {
          lat: this.lat.value!,
          lng: this.lng.value!,
        },
      }
    },
    streetViewUrl(): ValidatedResponse<string> {
      if (!this.lat.valid || !this.lng.valid) {
        return { valid: false }
      }

      return {
        valid: true,
        value: `https://maps.googleapis.com/maps/api/streetview?size=550x350&location=${this.lat.value},${this.lng.value}&key=${config.googleApiKey}&fov=120&pitch=25&source=outdoor`,
      }
    },
  },
  methods: {
    hasField(fieldKey: string): boolean {
      return getNestedValue(this.unitInfo, [fieldKey], undefined) !== undefined
        ? true
        : false
    },
  },
})
